import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Phone } from 'lucide-react';
import Link from 'next/link';
import { OPERATIONAL_HUB_URL } from '@/modules/shared/lib/constants';
function BookCallButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button variant="outline" className="w-full" asChild={true}><Link href={OPERATIONAL_HUB_URL}>Book a Call<Phone className="size-4" /></Link></Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { BookCallButton };